import React from 'react';
import { BookOpen, ExternalLink } from 'lucide-react';

/**
 * Carrousel « Plans de lecture » YouVersion (extrait de HomeScreen).
 * Contenu codé en dur (liens bible.com de la Pasteure). Markup identique.
 */

const PCC_ORG_URL = 'https://www.bible.com/organizations/f89aceb9-6f57-455c-8444-566c9ce1bb59';

const YOUVERSION_PLANS = [
  { id: '69867', title: "L'adoration qui touche le cœur de Dieu", image: 'https://imageproxy.youversionapi.com/https://s3.amazonaws.com/yvplans/69867/1280x720.jpg', url: 'https://www.bible.com/fr/reading-plans/69867-ladoration-qui-touche-le-coeur-de-dieu' },
  { id: '70176', title: 'Guérison & Délivrance — Jésus agit encore aujourd\'hui', image: 'https://imageproxy.youversionapi.com/https://s3.amazonaws.com/yvplans/70176/1280x720.jpg', url: 'https://www.bible.com/fr/reading-plans/70176-guerison-delivrance-jesus-agit-encore-aujourd' },
  { id: '69777', title: 'La fidélité silencieuse de Dieu', image: 'https://imageproxy.youversionapi.com/https://s3.amazonaws.com/yvplans/69777/1280x720.jpg', url: 'https://www.bible.com/fr/reading-plans/69777-la-fidelite-silencieuse-de-dieu' },
  { id: '69312', title: 'Pâques — La victoire qui te remet debout', image: 'https://imageproxy.youversionapi.com/https://s3.amazonaws.com/yvplans/69312/1280x720.jpg', url: 'https://www.bible.com/fr/reading-plans/69312-paques-la-victoire-qui-te-remet-debout' },
  { id: '68998', title: 'Dieu restaure ta santé mentale', image: 'https://imageproxy.youversionapi.com/https://s3.amazonaws.com/yvplans/68998/1280x720.jpg', url: 'https://www.bible.com/fr/reading-plans/68998-dieu-restaure-ta-sante-mentale' },
];

export default function ReadingPlansSection({ props = {} } = {}) {
  const sectionTitle = props.title || 'Plans de lecture';
  // Repli sur les plans codés quand aucun plan n'est saisi (3.2).
  const plans = Array.isArray(props.plans) && props.plans.length > 0
    ? props.plans.filter((p) => p && (p.url || p.image)).map((p, i) => ({
        id: p.url || p.id || `plan-${i}`, title: p.title || '', image: p.image || '', url: p.url || '#',
      }))
    : YOUVERSION_PLANS;
  return (
    <div className="py-6 bg-pcc-bg">
      <div className="flex items-center gap-2 px-4 mb-4">
        <BookOpen size={20} className="text-[#9398DE]" />
        <h2 className="text-lg font-bold text-pcc-text">{sectionTitle}</h2>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-2 px-4 snap-x">
        <a href={PCC_ORG_URL} target="_blank" rel="noopener noreferrer" className="flex-shrink-0 w-[200px] snap-start group">
          <div className="rounded-2xl overflow-hidden shadow-md transition-all group-hover:shadow-lg h-full bg-pcc-card">
            <div className="w-[200px] h-[112px] bg-[#9398DE] flex items-center justify-center">
              <img src="/Logo_Lion.png" alt="PCC" className="w-16 h-16 object-contain" />
            </div>
            <div className="p-3">
              <h3 className="text-xs font-bold leading-tight text-pcc-text">Paris Centre Chrétien</h3>
              <p className="text-[10px] mt-1 text-pcc-text-muted">Tous nos plans de lecture</p>
              <div className="flex items-center gap-1 mt-1.5">
                <ExternalLink size={11} className="text-[#9398DE]" />
                <span className="text-[10px] text-[#9398DE] font-medium">YouVersion</span>
              </div>
            </div>
          </div>
        </a>

        {plans.map((plan) => (
          <a key={plan.id} href={plan.url} target="_blank" rel="noopener noreferrer" className="flex-shrink-0 w-[200px] snap-start group">
            <div className="rounded-2xl overflow-hidden shadow-md transition-all group-hover:shadow-lg bg-pcc-card">
              <div className="w-[200px] h-[112px] overflow-hidden relative">
                <img
                  src={plan.image}
                  alt={plan.title}
                  className="w-full h-full object-cover transition-transform group-hover:scale-105"
                  loading="lazy"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = 'none';
                    e.target.parentElement.classList.add('bg-[#9398DE]', 'flex', 'items-center', 'justify-center', 'p-3');
                    const fallback = document.createElement('span');
                    fallback.className = 'text-white text-xs font-bold text-center leading-tight';
                    fallback.textContent = plan.title;
                    e.target.parentElement.appendChild(fallback);
                  }}
                />
              </div>
              <div className="p-3">
                <h3 className="text-xs font-bold line-clamp-2 leading-tight text-pcc-text">{plan.title}</h3>
                <div className="flex items-center gap-1 mt-1.5">
                  <ExternalLink size={11} className="text-[#9398DE]" />
                  <span className="text-[10px] text-[#9398DE] font-medium">YouVersion</span>
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>
      <p className="text-xs mt-3 text-center text-pcc-text-muted">Proposés par Paris Centre Chrétien sur YouVersion</p>
    </div>
  );
}
